RivalIQ.apps.Favorites.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    // Collection used to parse metrics to and from a format usable by the metric
    // editor
    collections.Metrics = Backbone.Collection.extend({
        model: App.models.Metric,
        // Return metric definitions with the base metric applied
        toMetrics: function (baseMetric) {
            const me = this;

            return me.map(function (metric) {
                return metric.toMetric(baseMetric);
            });
        },

        getValidChannels: function () {
            const me = this;

            let validChannels = me.validChannels;
            if (_.isFunction(me.validChannels)) {
                validChannels = me.validChannels();
            }
            return validChannels || RivalIQ.data.channels.forAnalyze().withAccess().notHidden(true);
        },

        initialize: function (models, options) {
            const me = this;

            me.validChannels = _.get(options, 'validChannels');
        }
    });
});
